module.exports = __webpack_public_path__ + "static/img/public.3cd0854f.png";